import React from 'react'

const UserProvider = React.createContext()
export default UserProvider
